import { useEffect, useState } from 'react';
import { addNetworkStatusListener, getNetworkStatus } from '../native/bridge';

interface NetworkStatus {
  connected?: boolean;
}

function readBrowserOnline(): boolean {
  if (typeof navigator === 'undefined') return true;
  return navigator.onLine !== false;
}

export function useOnline(): boolean {
  const [online, setOnline] = useState(readBrowserOnline);

  useEffect(() => {
    let active = true;
    let cleanupNetworkListener: (() => void) | null = null;

    const handleBrowserOnline = () => setOnline(true);
    const handleBrowserOffline = () => setOnline(false);

    window.addEventListener('online', handleBrowserOnline);
    window.addEventListener('offline', handleBrowserOffline);

    void getNetworkStatus()
      .then((status) => {
        if (active && typeof status?.connected === 'boolean') setOnline(status.connected);
      })
      .catch(() => undefined);

    void addNetworkStatusListener((status: NetworkStatus) => {
      if (active && typeof status.connected === 'boolean') setOnline(status.connected);
    })
      .then((cleanup) => {
        if (!active) {
          cleanup();
          return;
        }
        cleanupNetworkListener = cleanup;
      })
      .catch(() => undefined);

    return () => {
      active = false;
      window.removeEventListener('online', handleBrowserOnline);
      window.removeEventListener('offline', handleBrowserOffline);
      cleanupNetworkListener?.();
    };
  }, []);

  return online;
}
